<template>
	<div class="container">
		<el-container>
			<el-container>
				<div class="main_box">
					<div class="search_box">
						<div class="search_el">
							<div class="search_el_el">
								<div class="tit">User Name</div>
								<el-input v-model="query.username" placeholder="Please enter" clearable></el-input>
							</div>
							<div class="search_el_el"></div>
						</div>
						<div class="btn_box">
							<van-button class="btn_el" round color="linear-gradient(to right, #7BC1FF, #4886FF)" @click="search">Search</van-button>
						</div>
					</div>
					<!--表格-->
					<div class="table_box">
						<el-table v-loading="tableLoading" :data="tableData" border class="table_el" ref="multipleTable" header-cell-class-name="table-header">
							<el-table-column prop="user_id" label="User ID" width="150" :show-overflow-tooltip="true"></el-table-column>
							<el-table-column prop="username" label="User Name" width="150" :show-overflow-tooltip="true"></el-table-column>
							<!-- <el-table-column prop="" label="Affiliated Enterprises" :show-overflow-tooltip="true">
								<template #default="scope">
									{{ scope.row.company_name || '/' }}
								</template>
							</el-table-column> -->
							<el-table-column prop="" label="Department" :show-overflow-tooltip="true">
								<template #default="scope">
									{{ scope.row.departments_name || '/' }}
								</template>
							</el-table-column>
							<el-table-column prop="id" label="Operation" width="120" align="center">
								<template #default="scope">
									<div v-if="scope.row.id == selectedIds" class="inline_btn">
										<el-button disabled type="primary" size="mini">Choose</el-button>
									</div>
									<div v-else class="inline_btn">
										<el-button type="primary" size="mini" @click="handleClick('Choose', scope.row)">Choose</el-button>
									</div>
								</template>
							</el-table-column>
						</el-table>
						<div class="pagination">
							<el-pagination
								@size-change="handleSizeChange"
								@current-change="handlePageChange"
								:current-page="query.page"
								:page-sizes="[5, 10, 20, 50]"
								:page-size="query.page_size"
								layout="total, sizes, prev, pager, next"
								:total="pageTotal"
							>
							</el-pagination>
						</div>
					</div>
					<!--表格-->
				</div>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { usersList } from '@/api/system/user';
import { departmentsEditUser } from '@/api/docManage/configureDocControl/index';
export default {
	props: ['type', 'selectedId', 'departmentId'],
	components:{},
	data() {
		return {
			isLoading: true,
			query: {
				username: '',
				status: 1,
				page: 1,
				page_size: 5
			},
			tableLoading: false,
			tableData: [],
			pageTotal: 0,  //总条数
			selectedIds: null,
		}
	},
	created(){
		let that = this;
		that.selectedIds = that.selectedId;
	},
	mounted() {
		let that = this;
		that.isLoading = false;
		that.getTableData();
	},
	watch: {
		//
	},
	methods: {
		//获取表格数据
		getTableData() {
			let that = this;
			that.tableLoading = true;
			usersList(that.query).then(res => {
				that.tableLoading = false;
				if(res.code == 200) {
					that.tableData = [];
					that.$nextTick(() => {
						that.pageTotal = res.data.total;
						that.tableData = res.data.data;
					});
				}else {
					that.$message(res.msg);
				}
			});
		},
		//搜索
		search(formName) {
			let that = this;
			that.getTableData();
		},
		//条数选择
		handleSizeChange(value) {
			let that = this;
			that.query.page_size = value;
			that.getTableData();
		},
		//页数跳转
		handlePageChange(value) {
			let that = this;
			that.query.page = value;
			that.getTableData();
		},
		//操作按钮点击
		handleClick(name, value) {
			let that = this;
			switch (name) {
			    case 'Choose':
					that.$toast.loading({ duration: 0, forbidClick: true });
					departmentsEditUser({ id: that.departmentId, resources_userid: value.id }).then(res => {
						if(res.code == 200) {
							that.$toast.clear();
							that.$message.success('Operation Successful');
							that.selectedIds = value.id;
							that.getTableData();
							that.$emit('update-data');
						}
					});
				break;
			}
		}
	}
}
</script>

<style lang="less" scoped>
//主要内容
.main_box{
	width: 100%;
	//表格
	.table_box{
		width: 100%;
		padding-top: 20px;
		.inline_btn{
			display: inline-block;
		}
		.pagination {
			margin: 10px 0;
			text-align: right;
		}
		.mr_l{
			margin-left: 10px;
		}
	}
	//搜索
	.search_box{
		.search_el{
			display: flex;
			padding-bottom: 10px;
			.search_el_el{
				flex: 1;
			}
			.mr_r{
				margin-right: 10px;
			}
			.mr_l{
				margin-left: 10px;
			}
		}
	}
	.btn_box{
		text-align: right;
		.btn_el{
			margin-left: 10px;
			padding: 12px 24px;
			.van-button__text{
				font-size: 16px;
			}
		}
	}
}
</style>
